import { render, staticRenderFns } from "./NewsDetail2.vue?vue&type=template&id=adbedfb8&scoped=true"
var script = {}
import style0 from "./NewsDetail2.vue?vue&type=style&index=0&id=adbedfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbedfb8",
  null
  
)

export default component.exports